import React from 'react';
import {get} from 'lodash';

import {BonusEligibleUntil} from '/component/partial/report/BonusEligibleUntil';
import {useTranslation} from '/provider/TranslationProvider';

interface CabEligibleUntilProps {
  item: {
    newOrderingEntitiesCount?: number;
    cabFQV: string;
    cabRemainingEligibility?: number;
    [key: string]: any; // Allow additional props to prevent TS errors from dynamic keys
  };
}

export const CabEligibleUntil: React.FC<CabEligibleUntilProps> = ({
  item = {},
}) => {
  const itemData = {
    newOrderingEntitiesCount: get(item, 'newOrderingEntitiesCount', null),
    fqv: get(item, 'cabFQV', null),
    remainingEligibility: get(item, 'cabRemainingEligibility', null),
  };

  const {ts} = useTranslation('report.record.cabEligibleUntil');

  return (
    <BonusEligibleUntil
      item={itemData}
      orderingEntitiesName={ts('cabOrderingEntities', 'CAB Ordering Entities')}
      fqvName={ts('cabFqv', 'CAB FQV ')}
    />
  );
};

export default CabEligibleUntil;
